/* unplugin-vue-components disabled */import script from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-admin.vue?vue&type=script&lang=ts&setup=true"

import "./manage-admin.vue?vue&type=style&index=0&id=6306db80&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6306db80"]])

export default __exports__